<template>
	<div>
		<div class="configuration-read-only-data-info">
			<h3 class="line-header">Evaluation Factors</h3>
			<p>
				The complete list of factors is used to determine the likelihood
				of fraud. The outcome is a cumulative score assigned to both
				True Fraud and Friendly Fraud probability. Higher scores
				indicate a higher degree of certainty.
			</p>
		</div>
		<v-data-table
			:headers="headers"
			:items="factors"
			:expanded.sync="expanded"
			item-key="factorConfiguration.factorId"
			:item-class="factorItemClasses"
			mobile-breakpoint="0"
			show-expand
		>
			<template v-slot:expanded-item="{ headers, item }">
				<td :colspan="headers.length">
					<template>
						<!-- tables loops over factors as an 'item' -->
						<div class="factor-details">
							<div class="description"
								v-if="item.factorConfiguration.description"
							>
								<h3>Description</h3>
								{{ item.factorConfiguration.description }}
							</div>
							<div class="whyitworks"
								v-if="item.factorConfiguration.whyItWorks"
							>
								<h3>Why It Works</h3>
								{{ item.factorConfiguration.whyItWorks }}
							</div>
							<div class="knowledge-base-url" v-if="item.factorConfiguration.knowledgeBaseUrl">
								<a :href="item.factorConfiguration.knowledgeBaseUrl" target="_blank">Learn More</a>
							</div>
							<div class="thresholds">
								<div
									class="threshold-item"
									v-for="threshold in item.factorConfiguration
										.thresholds"
									:key="threshold.id"
								>
									<div class="threshold-label">
										{{ threshold.label }}
									</div>
									<div class="threshold-levels">
										<div
											v-for="(inputField,
											index) in threshold.levels
												.inputFields"
											:key="index"
											class="threshold-levels-loop"
										>
											<!-- only show these labels if there are multiple levels... no ALL -->
											<template
												v-if="
													threshold.levels.inputFields
														.length > 1
												"
											>
												<v-chip
													:class="inputField.fieldId"
													:pill="true"
													:title="inputField.fieldId"
													>{{
														inputField.fieldId
															.charAt(0)
															.toUpperCase()
													}}</v-chip
												>
											</template>

											<v-text-field
												class="threshold-level-item"
												v-model="inputField.fieldValue"
												:label="threshold.placeholder"
												outlined
												readonly
											></v-text-field>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	/**
	 * @fileoverview configuration-table.vue displays a profile's factor configurations in a flat list.
	 * It relies on vuex to map the state variables from the store files.
	 * 
	 * @author David Barnett <david.barnett@quavo.com>
	 */
	import { mapState } from "vuex";

	export default {
		props: {
			isReadOnly: Boolean,	// Boolean flag for if the list is modifiable
		},
		data() {
			return {
				expanded: [],	// list of expanded items
				singleExpand: false,	// true if only one item can be expanded at a time
				/**
				 * Headers for the factors data table
				 */
				headers: [
					{ text: "", value: "data-table-expand" },
					{
						text: "Evalution Factor",
						align: "start",
						sortable: false,
						value: "factorConfiguration.label",
						class: "factor-item-key",
						cellClass: "factor-item-key", // cellClass won't work until vuetify v2.4.0
					},
					{
						text: "Fraud Type",
						value: "factorConfiguration.type",
						class: "factor-item-type",
						cellClass: "factor-item-type"
					},
					{
						text: "Scope",
						value: "factorConfiguration.scope",
						class: "factor-item-scope",
						cellClass: "factor-item-scope"
					},
					{
						text: "Category",
						value: "factorConfiguration.category",
						class: "factor-item-category",
						cellClass: "factor-item-category"
					}
				],
			};
		},
		computed: {
			...mapState({
				factors: (state) => state.config.factorConfigurations,
			}),
		},
		methods: {
			/**
			 * Factor items classes
			 */
			factorItemClasses() {
				return 'factor-item';
			}
		},
	};
</script>